export interface JAICreative {
    ClientKey?: string;
    Id: string;
    Status?: string
}